import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _32f4939d = () => interopDefault(import('../../../pages/agendamento.vue' /* webpackChunkName: "pages/agendamento" */))
const _4e9452b3 = () => interopDefault(import('../../../pages/agendamento-online.vue' /* webpackChunkName: "pages/agendamento-online" */))
const _52a723b4 = () => interopDefault(import('../../../pages/app-vidaas.vue' /* webpackChunkName: "pages/app-vidaas" */))
const _79674002 = () => interopDefault(import('../../../pages/cidade/index.vue' /* webpackChunkName: "pages/cidade/index" */))
const _1783f541 = () => interopDefault(import('../../../pages/compatibilidade.vue' /* webpackChunkName: "pages/compatibilidade" */))
const _4380344c = () => interopDefault(import('../../../pages/compra-pedido.vue' /* webpackChunkName: "pages/compra-pedido" */))
const _7599bd02 = () => interopDefault(import('../../../pages/contato.vue' /* webpackChunkName: "pages/contato" */))
const _78679a97 = () => interopDefault(import('../../../pages/contato-suporte.vue' /* webpackChunkName: "pages/contato-suporte" */))
const _bc125968 = () => interopDefault(import('../../../pages/delivery.vue' /* webpackChunkName: "pages/delivery" */))
const _3ec56dd4 = () => interopDefault(import('../../../pages/disabled.vue' /* webpackChunkName: "pages/disabled" */))
const _fa10e0a6 = () => interopDefault(import('../../../pages/documentos-necessarios.vue' /* webpackChunkName: "pages/documentos-necessarios" */))
const _7728603a = () => interopDefault(import('../../../pages/dpn.vue' /* webpackChunkName: "pages/dpn" */))
const _2d3ce804 = () => interopDefault(import('../../../pages/dpn-cd.vue' /* webpackChunkName: "pages/dpn-cd" */))
const _cbf957ca = () => interopDefault(import('../../../pages/dpn-rfb.vue' /* webpackChunkName: "pages/dpn-rfb" */))
const _6f96346f = () => interopDefault(import('../../../pages/duvidas-frequentes.vue' /* webpackChunkName: "pages/duvidas-frequentes" */))
const _3e94e03e = () => interopDefault(import('../../../pages/empresa.vue' /* webpackChunkName: "pages/empresa" */))
const _171574e1 = () => interopDefault(import('../../../pages/indicacao-de-uso.vue' /* webpackChunkName: "pages/indicacao-de-uso" */))
const _0c15c057 = () => interopDefault(import('../../../pages/internacional.vue' /* webpackChunkName: "pages/internacional" */))
const _962813d8 = () => interopDefault(import('../../../pages/links-importantes.vue' /* webpackChunkName: "pages/links-importantes" */))
const _171251e7 = () => interopDefault(import('../../../pages/mapa-site.vue' /* webpackChunkName: "pages/mapa-site" */))
const _62ad7666 = () => interopDefault(import('../../../pages/noticias.vue' /* webpackChunkName: "pages/noticias" */))
const _7f0da9ee = () => interopDefault(import('../../../pages/pagamento-realizado.vue' /* webpackChunkName: "pages/pagamento-realizado" */))
const _59f2281a = () => interopDefault(import('../../../pages/parceiro-contador.vue' /* webpackChunkName: "pages/parceiro-contador" */))
const _caaf0ec4 = () => interopDefault(import('../../../pages/perguntas-frequentes.vue' /* webpackChunkName: "pages/perguntas-frequentes" */))
const _502e08dc = () => interopDefault(import('../../../pages/politicas.vue' /* webpackChunkName: "pages/politicas" */))
const _33aa72e1 = () => interopDefault(import('../../../pages/renova-nuvem.vue' /* webpackChunkName: "pages/renova-nuvem" */))
const _1263f046 = () => interopDefault(import('../../../pages/renovacao-online.vue' /* webpackChunkName: "pages/renovacao-online" */))
const _60d4b519 = () => interopDefault(import('../../../pages/seja-uma-revenda.vue' /* webpackChunkName: "pages/seja-uma-revenda" */))
const _4e813f46 = () => interopDefault(import('../../../pages/sispass.vue' /* webpackChunkName: "pages/sispass" */))
const _996c009c = () => interopDefault(import('../../../pages/sobre-sdconsulta.vue' /* webpackChunkName: "pages/sobre-sdconsulta" */))
const _24155d84 = () => interopDefault(import('../../../pages/solicitacao-consulta-credito.vue' /* webpackChunkName: "pages/solicitacao-consulta-credito" */))
const _39346b0c = () => interopDefault(import('../../../pages/solicitacao-link.vue' /* webpackChunkName: "pages/solicitacao-link" */))
const _00c6da3a = () => interopDefault(import('../../../pages/status-pagamento.vue' /* webpackChunkName: "pages/status-pagamento" */))
const _11e032da = () => interopDefault(import('../../../pages/suporte-a1.vue' /* webpackChunkName: "pages/suporte-a1" */))
const _11a7d4d6 = () => interopDefault(import('../../../pages/suporte-a3.vue' /* webpackChunkName: "pages/suporte-a3" */))
const _731a9ec5 = () => interopDefault(import('../../../pages/suporte-vidaas.vue' /* webpackChunkName: "pages/suporte-vidaas" */))
const _4641ba7c = () => interopDefault(import('../../../pages/termoparceria.vue' /* webpackChunkName: "pages/termoparceria" */))
const _419b67ba = () => interopDefault(import('../../../pages/trabalheConosco.vue' /* webpackChunkName: "pages/trabalheConosco" */))
const _68422384 = () => interopDefault(import('../../../pages/videoconferencia.vue' /* webpackChunkName: "pages/videoconferencia" */))
const _9e0508ac = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b5bf7c96 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _66885e97 = () => interopDefault(import('../../../pages/cidade/_name.vue' /* webpackChunkName: "pages/cidade/_name" */))
const _931279dc = () => interopDefault(import('../../../pages/saiba-mais/_nome.vue' /* webpackChunkName: "pages/saiba-mais/_nome" */))
const _7385030c = () => interopDefault(import('../../../pages/_categoria.vue' /* webpackChunkName: "pages/_categoria" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/agendamento",
    component: _32f4939d,
    name: "agendamento"
  }, {
    path: "/agendamento-online",
    component: _4e9452b3,
    name: "agendamento-online"
  }, {
    path: "/app-vidaas",
    component: _52a723b4,
    name: "app-vidaas"
  }, {
    path: "/cidade",
    component: _79674002,
    name: "cidade"
  }, {
    path: "/compatibilidade",
    component: _1783f541,
    name: "compatibilidade"
  }, {
    path: "/compra-pedido",
    component: _4380344c,
    name: "compra-pedido"
  }, {
    path: "/contato",
    component: _7599bd02,
    name: "contato"
  }, {
    path: "/contato-suporte",
    component: _78679a97,
    name: "contato-suporte"
  }, {
    path: "/delivery",
    component: _bc125968,
    name: "delivery"
  }, {
    path: "/disabled",
    component: _3ec56dd4,
    name: "disabled"
  }, {
    path: "/documentos-necessarios",
    component: _fa10e0a6,
    name: "documentos-necessarios"
  }, {
    path: "/dpn",
    component: _7728603a,
    name: "dpn"
  }, {
    path: "/dpn-cd",
    component: _2d3ce804,
    name: "dpn-cd"
  }, {
    path: "/dpn-rfb",
    component: _cbf957ca,
    name: "dpn-rfb"
  }, {
    path: "/duvidas-frequentes",
    component: _6f96346f,
    name: "duvidas-frequentes"
  }, {
    path: "/empresa",
    component: _3e94e03e,
    name: "empresa"
  }, {
    path: "/indicacao-de-uso",
    component: _171574e1,
    name: "indicacao-de-uso"
  }, {
    path: "/internacional",
    component: _0c15c057,
    name: "internacional"
  }, {
    path: "/links-importantes",
    component: _962813d8,
    name: "links-importantes"
  }, {
    path: "/mapa-site",
    component: _171251e7,
    name: "mapa-site"
  }, {
    path: "/noticias",
    component: _62ad7666,
    name: "noticias"
  }, {
    path: "/pagamento-realizado",
    component: _7f0da9ee,
    name: "pagamento-realizado"
  }, {
    path: "/parceiro-contador",
    component: _59f2281a,
    name: "parceiro-contador"
  }, {
    path: "/perguntas-frequentes",
    component: _caaf0ec4,
    name: "perguntas-frequentes"
  }, {
    path: "/politicas",
    component: _502e08dc,
    name: "politicas"
  }, {
    path: "/renova-nuvem",
    component: _33aa72e1,
    name: "renova-nuvem"
  }, {
    path: "/renovacao-online",
    component: _1263f046,
    name: "renovacao-online"
  }, {
    path: "/seja-uma-revenda",
    component: _60d4b519,
    name: "seja-uma-revenda"
  }, {
    path: "/sispass",
    component: _4e813f46,
    name: "sispass"
  }, {
    path: "/sobre-sdconsulta",
    component: _996c009c,
    name: "sobre-sdconsulta"
  }, {
    path: "/solicitacao-consulta-credito",
    component: _24155d84,
    name: "solicitacao-consulta-credito"
  }, {
    path: "/solicitacao-link",
    component: _39346b0c,
    name: "solicitacao-link"
  }, {
    path: "/status-pagamento",
    component: _00c6da3a,
    name: "status-pagamento"
  }, {
    path: "/suporte-a1",
    component: _11e032da,
    name: "suporte-a1"
  }, {
    path: "/suporte-a3",
    component: _11a7d4d6,
    name: "suporte-a3"
  }, {
    path: "/suporte-vidaas",
    component: _731a9ec5,
    name: "suporte-vidaas"
  }, {
    path: "/termoparceria",
    component: _4641ba7c,
    name: "termoparceria"
  }, {
    path: "/trabalheConosco",
    component: _419b67ba,
    name: "trabalheConosco"
  }, {
    path: "/videoconferencia",
    component: _68422384,
    name: "videoconferencia"
  }, {
    path: "/",
    component: _9e0508ac,
    name: "index"
  }, {
    path: "/blog/:slug?",
    component: _b5bf7c96,
    name: "blog-slug"
  }, {
    path: "/cidade/:name",
    component: _66885e97,
    name: "cidade-name"
  }, {
    path: "/saiba-mais/:nome?",
    component: _931279dc,
    name: "saiba-mais-nome"
  }, {
    path: "/:categoria",
    component: _7385030c,
    name: "categoria"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
